import { reactive as w, computed as i, onMounted as h, onUnmounted as p } from "vue";
const U = (r) => {
  let u;
  const s = w({
    weeks: "00",
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00"
  }), o = i(() => r.value.maxUnit === "weeks"), a = i(
    () => ["days", "weeks"].includes(r.value.maxUnit)
  );
  function n(t, e = 1) {
    return Math.floor(Math.max(t, 0)).toString().padStart(e, "0");
  }
  function c() {
    const t = Date.now();
    let e = r.value.date.getTime() - t;
    o.value && (s.weeks = n(e / (1e3 * 60 * 60 * 24 * 7), 2), e %= 1e3 * 60 * 60 * 24 * 7), a.value && (s.days = n(e / (1e3 * 60 * 60 * 24), 2), e %= 1e3 * 60 * 60 * 24), s.hours = n(e / (1e3 * 60 * 60), 2), e %= 1e3 * 60 * 60, s.minutes = n(e / (1e3 * 60), 2), e %= 1e3 * 60, s.seconds = n(e / 1e3, 2);
  }
  function f(t) {
    switch (t) {
      case "weeks":
        return;
      case "days":
        return "weeks";
      case "hours":
        return "days";
      case "minutes":
        return "hours";
      case "seconds":
        return "minutes";
      default:
        return;
    }
  }
  function v(t) {
    if (t === "weeks" && !o.value || t === "days" && !a.value) return !0;
    if ((/* @__PURE__ */ new Set([
      "days",
      "hours",
      "minutes",
      "seconds"
    ])).has(t)) return !1;
    const l = Number(s[t]) === 0, d = f(t), m = d ? Number(s[d]) !== 0 : !1;
    return t === "weeks" && l ? !0 : l && !m;
  }
  return h(() => {
    u = setInterval(() => {
      c();
    }, 1e3);
  }), p(() => {
    u && (clearInterval(u), u = void 0);
  }), c(), i(() => {
    const t = [];
    for (const e of Object.keys(s))
      v(e) || t.push({
        label: r.value.labels[e],
        value: s[e],
        unit: e
      });
    return t;
  });
};
export {
  U as useCountdown
};
